module.exports = __webpack_public_path__ + "static/img/logo_kr_01.af7a146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_kr_01.png
// module id = a3EF
// module chunks = 1